var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "198.109",
        height: "44.047",
        viewBox: "0 0 198.109 44.047",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_1",
            "data-name": "Group 1",
            transform: "translate(-37.719 -172.462)",
          },
        },
        [
          _c("path", {
            attrs: {
              id: "Path_12",
              "data-name": "Path 12",
              d: "M139,207.859c-.236,1.548-.46,3.053-.742,4.9-1.038-1.7-1.948-3.1-2.763-4.546a2.322,2.322,0,0,0-1.974-1.32c-1.573-.169-3.125-.5-4.686-.785-4.011-.725-5.863-3.353-5.192-7.385q1.752-10.565,3.526-21.13c.62-3.7,3.5-5.652,7.229-5.011,5.841,1.008,11.7,1.97,17.545,2.931,4.311.709,6.17,3.366,5.432,7.705q-1.778,10.451-3.5,20.911a5.687,5.687,0,0,1-6.512,5.027c-2.594-.312-5.162-.822-7.743-1.244C139.45,207.888,139.272,207.884,139,207.859Zm-13.244-7.942a3.615,3.615,0,0,0,3.193,3.956q9.1,1.512,18.2,3.037a3.555,3.555,0,0,0,4.483-3.109q1.841-10.78,3.6-21.569c.4-2.446-.742-4.011-3.184-4.424q-8.933-1.519-17.878-2.956c-2.977-.477-4.386.649-4.863,3.631-.751,4.69-1.552,9.372-2.333,14.053C126.548,195.109,126.122,197.686,125.755,199.917Z",
              transform: "translate(-57.303)",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_13",
              "data-name": "Path 13",
              d: "M68.376,215.215c.164.843.308,1.594.476,2.48-2.13.413-4.2.873-6.293,1.2a2.888,2.888,0,0,0-2.45,1.7c-.6,1.252-1.384,2.417-2.269,3.922-.329-1.683-.595-3.053-.886-4.538-2.32.443-4.542.919-6.786,1.269a14.261,14.261,0,0,1-3.935.249,5.513,5.513,0,0,1-4.517-4.589q-1.993-11.255-3.922-22.518a5.808,5.808,0,0,1,4.787-6.55q9.566-1.734,19.157-3.319a5.733,5.733,0,0,1,6.394,4.77c-.78.143-1.561.291-2.315.43-1.257-2.472-2.134-2.931-4.905-2.455q-8.819,1.506-17.629,3.075c-2.235.4-3.26,2.02-2.864,4.281q1.854,10.547,3.661,21.1c.443,2.59,1.923,3.72,4.517,3.235,6.369-1.194,12.733-2.425,19.1-3.636C67.878,215.287,68.059,215.261,68.376,215.215Z",
              transform: "translate(0 -8.01)",
              fill: "#EC4B1D",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_14",
              "data-name": "Path 14",
              d: "M431.167,213.881v-5.257h6.647c2.2,0,4.4.022,6.609-.006,1.581-.022,2.319-.9,2.287-2.626a2.038,2.038,0,0,0-2.292-2.292c-2.347-.016-4.7-.115-7.035.016-5.864.328-8.49-4.94-7.478-9.524.853-3.857,3.036-6.22,7.385-6.116,4.59.109,9.18.022,13.868.022v5.52h-5.143c-2.779,0-5.553-.011-8.332.006a2.152,2.152,0,0,0-2.2,2.412,2.113,2.113,0,0,0,2.2,2.249c2.347.011,4.694,0,7.035.006,4.18.005,6.2,1.318,7.4,5.35a8.159,8.159,0,0,1-2.183,8.8,5.8,5.8,0,0,1-3.4,1.516c-4.973.169-9.957.076-14.935.076A2.5,2.5,0,0,1,431.167,213.881Z",
              transform: "translate(-248.937 -8.559)",
              fill: "#222",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_15",
              "data-name": "Path 15",
              d: "M506.134,214.1v-5.263h4.492c2.921,0,5.837.011,8.759-.006a2.5,2.5,0,0,0,2.495-2.549,2.408,2.408,0,0,0-2.473-2.369c-2.347-.011-4.694-.087-7.036.016-5.077.219-7.741-3.545-7.495-8.195.17-3.168,1.406-5.711,4.491-7.046a2.208,2.208,0,0,1,.826-.219c5.3-.011,10.6-.011,16.013-.011v5.383h-1.565c-3.922,0-7.85-.006-11.773.006a2.141,2.141,0,0,0-2.3,2.33,2.189,2.189,0,0,0,2.281,2.331c2.916.049,5.837,0,8.747.169,3.08.181,4.875,2.15,5.537,4.956.766,3.261.711,6.554-2.068,8.994a5.974,5.974,0,0,1-3.386,1.537c-5.022.17-10.05.082-15.072.082A1.774,1.774,0,0,1,506.134,214.1Z",
              transform: "translate(-291.731 -8.78)",
              fill: "#222",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_16",
              "data-name": "Path 16",
              d: "M262.926,213.972v-5.246h6.067c2.391,0,4.781.016,7.178-.006a2.3,2.3,0,0,0,2.412-2.577,2.187,2.187,0,0,0-2.352-2.434c-2.44-.022-4.885-.087-7.32.005-6.882.274-8.561-7.38-6.56-11.439a6.759,6.759,0,0,1,6.861-4.125c4.015.1,8.036.066,12.052,0,1.253-.022,1.762.263,1.74,1.647-.066,3.8,0,3.8-3.835,3.8-3.157,0-6.313-.011-9.47.006-1.75.011-2.44.733-2.418,2.451.022,1.636.711,2.325,2.38,2.331,2.44.011,4.88-.016,7.32.011,3.6.038,6.061,1.773,6.948,5.236s.3,6.68-2.566,9.114a4.721,4.721,0,0,1-2.675,1.176C273.484,214.027,268.276,213.972,262.926,213.972Z",
              transform: "translate(-153.222 -8.601)",
              fill: "#EC4B1D",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_17",
              "data-name": "Path 17",
              d: "M333.7,188.248a4.71,4.71,0,0,1,.624-.164c4.519-.377,4.519-.377,4.519,4.087,0,3.873-.131,7.752.033,11.62.246,5.832-3.583,9.6-8.813,10.29-3.348.443-6.56.093-9.382-2.09a7.377,7.377,0,0,1-3.266-5.493c-.186-6.056-.066-12.123-.066-18.31h5.3v1.521q0,6.885.006,13.77c.005,2.336.826,3.468,3.042,4.295,3.042,1.132,6.445.17,7.517-2.2a5.926,5.926,0,0,0,.476-2.347c.044-4.448.022-8.9.022-13.343C333.7,189.353,333.7,188.833,333.7,188.248Z",
              transform: "translate(-184.96 -8.48)",
              fill: "#EC4B1D",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_18",
              "data-name": "Path 18",
              d: "M373.977,193.58v-5.307c.47-.038.925-.109,1.379-.115,4.158-.011,8.321.082,12.479-.033,3.277-.087,5.6,1.274,6.773,4.24a8.61,8.61,0,0,1-.941,8.813,6.007,6.007,0,0,1-5.066,2.462c-1.816.022-3.633.016-5.449.038-2.484.033-3.8,1.307-3.851,3.807-.044,2.1-.011,4.2-.011,6.428h-5.214a3.536,3.536,0,0,1-.159-.76c-.006-2.676-.049-5.356.033-8.026.137-4.311,2.522-6.642,6.855-6.751,2.2-.055,4.4,0,6.6-.016a2.182,2.182,0,0,0,2.27-2.352,2.1,2.1,0,0,0-2.2-2.424c-3.873-.038-7.747-.016-11.62-.016C375.29,193.58,374.721,193.58,373.977,193.58Z",
              transform: "translate(-217.175 -8.587)",
              fill: "#EC4B1D",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_19",
              "data-name": "Path 19",
              d: "M486.022,188.245h5.317v25.784h-5.317Z",
              transform: "translate(-281.007 -8.658)",
              fill: "#222",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_20",
              "data-name": "Path 20",
              d: "M80.549,234.058a10.214,10.214,0,0,1-9.835,9.971,10.074,10.074,0,0,1-10.249-9.042c-.025-.257-.017-.515-.025-.772-.021-.822.341-1.388,1.181-1.438.907-.055,1.308.531,1.392,1.379a11.414,11.414,0,0,0,.164,1.421,7.424,7.424,0,1,0,14.395-3.6c-.059-.215-.122-.426-.164-.641a1.191,1.191,0,0,1,.814-1.493,1.153,1.153,0,0,1,1.59.793C80.131,231.747,80.308,232.911,80.549,234.058Z",
              transform: "translate(-15.176 -38.271)",
              fill: "#EC4B1D",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_21",
              "data-name": "Path 21",
              d: "M154.411,235.616a28.226,28.226,0,0,0,3.226-.654,9.987,9.987,0,0,0,6.892-9.979c-.046-.9-.363-1.539-1.337-1.535s-1.358.6-1.333,1.523c.009.257.009.515,0,.776a7.411,7.411,0,1,1-14.648-1.915c.219-1.257-.093-1.94-.962-2.092s-1.421.371-1.687,1.607A10.215,10.215,0,0,0,154.411,235.616Z",
              transform: "translate(-71.215 -32.898)",
              fill: "#fff",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_22",
              "data-name": "Path 22",
              d: "M154.409,235.6a10.228,10.228,0,0,1-9.852-12.278c.266-1.236.814-1.759,1.687-1.607s1.185.835.962,2.092a7.411,7.411,0,1,0,14.648,1.915c.008-.257.008-.515,0-.776-.026-.923.375-1.522,1.332-1.522.975,0,1.291.637,1.337,1.535a9.981,9.981,0,0,1-6.892,9.979A26.5,26.5,0,0,1,154.409,235.6Z",
              transform: "translate(-71.212 -32.881)",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }